
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.59 13.426a2.018 2.018 0 010-2.852L10.575.59a2.016 2.016 0 012.852 0l9.983 9.983a2.016 2.016 0 010 2.852l-9.983 9.983a2.016 2.016 0 01-2.852 0z","fill":"#858ca8"}}),_c('g',{attrs:{"stroke":"#fff","stroke-linecap":"round","stroke-width":"1.219"}},[_c('path',{attrs:{"d":"M8.688 17.125v-3.25a3.25 3.25 0 013.25-3.25h4.875m0 0l-2.438-2.437m2.438 2.437l-2.438 2.438","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.688 10.219V7.375"}})])])
          )
        }
      }
    